import React from 'react';
import './Partnerships.css';

const PARTNERS = [
  {
    name: 'Research Girl',
    logo: '/images/partnerships/main-logos/researchgirllogo.webp',
    description: 'Empowering students through STEM research opportunities and mentorship, sharing our commitment to making advanced education accessible to all.',
    link: 'https://researchgirl.org',
  },
  {
    name: 'Congo Peace Academy',
    logo: '/images/partnerships/main-logos/cpa.webp',
    description: 'Providing educational resources and opportunities to underserved communities, fostering peace and long-term growth through education.',
    link: 'https://congopeaceacademy.org',
  },
  {
    name: 'Rochester Education Foundation',
    logo: '/images/partnerships/main-logos/ref.webp',
    description: 'Enhancing educational opportunities in Rochester through innovative programs and deep community engagement.',
    link: 'https://rochestereducation.org',
  },
  {
    name: 'Rochester Area Community Foundation',
    logo: '/images/partnerships/main-logos/racf.gif',
    description: 'Creating lasting positive change in education through strategic community investments and collaborative, cross-sector initiatives.',
    link: 'https://www.racf.org',
  },
  {
    name: 'Acting Globally',
    logo: '/images/partnerships/main-logos/actingglobally.webp',
    description: 'Expanding educational access worldwide through innovative outreach programs and meaningful cultural exchange.',
    link: 'https://actingglobally.org',
  },
];

const Partnerships = () => (
  <div className="partners-shell">
    <section className="partners-hero">
      <p className="partners-hero__badge">Partnerships</p>
      <h1>Organizations growing with us.</h1>
      <p>
        We believe collaboration multiplies impact. Our partners share a commitment to equitable
        education and help us reach students and communities we couldn't serve alone.
      </p>
    </section>

    <div className="partners-grid">
      {PARTNERS.map((partner) => (
        <article key={partner.name} className="partner-card">
          <div className="partner-card__logo">
            <img src={partner.logo} alt={`${partner.name} logo`} loading="lazy" />
          </div>
          <div className="partner-card__body">
            <h3>{partner.name}</h3>
            <p>{partner.description}</p>
            <a
              href={partner.link}
              className="partner-card__link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit partner →
            </a>
          </div>
        </article>
      ))}
    </div>

    <section className="partners-cta">
      <h2>Partner with us</h2>
      <p>
        We're always looking to collaborate with nonprofits, school districts, and foundations
        that share our vision of making quality college preparation accessible to every student.
      </p>
      <a href="mailto:staff@projectlevelthefield.com" className="partners-cta__button">
        Get in touch
      </a>
    </section>
  </div>
);

export default Partnerships;
